import { SEVERITY } from "helpers/utils.js";
import {
  GET_UNIT_OF_MEASUREMENTS,
  GET_UNIT_OF_MEASUREMENTS_SUCCESS,
  GET_UNIT_OF_MEASUREMENT_BY_ID_SUCCESS,
  GET_UNIT_OF_MEASUREMENTS_ERROR,
  UNIT_OF_MEASUREMENT_CLEAR_ERROR,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
  message: null,
};

const Category = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_UNIT_OF_MEASUREMENTS:
      return {
        ...state,
        loading: true,
      };
    case GET_UNIT_OF_MEASUREMENTS_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_UNIT_OF_MEASUREMENT_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_UNIT_OF_MEASUREMENTS_ERROR:
      let hasUniqueCode = payload.includes("UNIQUE_Code");
      return {
        ...state,
        message: {
          title: "Item",
          text: hasUniqueCode ? "Item is duplicate code." : payload,
          severity: SEVERITY.DANGER,
        },
      };
    case UNIT_OF_MEASUREMENT_CLEAR_ERROR:
      return {
        ...state,
        loading: false,
        message: null,
      };
    default:
      return state;
  }
};

export default Category;
